<template>
  <base-container ref="contain">
    <ArtisanGrid ref="sysMetaColumn" metaKey="SysMetaColumn" :query="query">
      <template slot="gridBtnAfter">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-copy-document"
          @click="autoCreate"
          >自动生成</el-button
        >
      </template>
    </ArtisanGrid>
  </base-container>
</template>

<script>
import { autoColumns } from "@/api/sys/meta";
export default {
  props: ["query"],
  methods: {
    autoCreate() {
      this.$refs.contain
        .prompt({
          titleAlign: "center",
          msg: "请输入实体名称",
        })
        .then((val) => {
          if (val) {
            autoColumns(this.query.metaId, val).then(() => {
              this.$refs.sysMetaColumn.reload();
            });
          } else {
            this.$message({
              type: "error",
              message: "实体名称必填",
            });
          }
        });
    },
  },
};
</script>

<style>
</style>